/* eslint-disable no-restricted-imports */
import { PropsWithChildren } from 'lib-shared-types-utils';

import { ComposeSmsModal } from 'app/components/appModals/components/composeSmsModal/composeSmsModal';
import NotificationsList from 'components/notifications/containers/notificationsList';
import AddCallerModal from 'components/shared/addCallerModal/containers/addCallerModal';
import AttachmentsPreviewModal from 'components/shared/attachmentsPreviewModal/containers/attachmentsPreviewModal';
import CompanyModal from 'components/shared/companyModal/containers/companyModal';
import ComposeEmailModal from 'components/shared/composeEmail/components/ComposeEmailModalContainer';
import ConfirmModal from 'components/shared/confirmModal/containers/confirmModal';
import FollowUpModal from 'components/shared/followUpModal/containers/followUpModal';
import TransferToAgentModal from 'components/shared/transferToAgentModal/containers/transferToAgentModal';
import TransferToNumberModal from 'components/shared/transferToNumberModal/containers/transferToNumberModal';
import TransferToQueueModal from 'components/shared/transferToQueueModal/components/TransferToQueueModal';
import { UserModal } from 'components/usersModal';
import { DixaMessengerWidget } from 'components/widget';
import { useFeatureFlag } from 'utils/featureFlagging/useFeatureFlag';

import { LayoutContainer } from './components/layoutContainer/layoutContainer';
import { useRegisterCommandHandlers } from './utils/useRegisterCommandHandlers/useRegisterCommandHandlers';

type LayoutProps = PropsWithChildren;

/** Represents the main layout of the application. */
export const LayoutView = ({ children }: LayoutProps): JSX.Element => {
  const appCommandComponents = useRegisterCommandHandlers();

  const { hasChatWithDixaSupport } = useFeatureFlag([
    'has-chat-with-dixa-support',
  ]);

  const modals = (
    <>
      <AddCallerModal />
      <AttachmentsPreviewModal />
      <CompanyModal />
      <ComposeEmailModal />
      <ComposeSmsModal />
      <ConfirmModal />
      <FollowUpModal />
      <TransferToAgentModal />
      <TransferToNumberModal />
      <TransferToQueueModal />
      <UserModal />
    </>
  );

  const widget = hasChatWithDixaSupport ? <DixaMessengerWidget /> : null;

  return (
    <>
      {appCommandComponents}
      {modals}
      {widget}
      <NotificationsList />

      <LayoutContainer>{children}</LayoutContainer>
    </>
  );
};
